
export { default as getGlobalHtmlAttrs } from "./getGlobalHtmlAttrs"